import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 491E8E53-19DC-4736-AA7F-F95AEB0F1696
 * name arrow-up-right-bold
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-right-bold.svg
 * tags
 */
export const ArrowUpRightBoldIcon = createSvgIcon(<><path d="M3 21V17H10.5C12.43 17 14 15.43 14 13.5V11H10L16 4L22 11H18V13.5C18 17.64 14.64 21 10.5 21H3Z" /></>, 'ArrowUpRightBoldIcon');
export default ArrowUpRightBoldIcon